import { Component, Input, OnChanges, ViewEncapsulation } from '@angular/core';
import { UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { QueryEditorComponent } from '../query-editor.component';
import { AuthService } from 'src/app/service/auth.service';

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: 'app-query-editor-group',
  templateUrl: './query-editor-group.component.html',
  styleUrls: ['./query-editor-group.component.scss'],
})
export class QueryEditorGroupComponent implements OnChanges {
  groupForm: UntypedFormGroup;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  @Input() data: any;
  @Input() isAiGenerated: boolean;

  groupsCollapsed = true;
  includedCount = 0;
  excludedCount = 0;

  constructor(
    private query: QueryEditorComponent,
    public auth: AuthService,
  ) {}

  ngOnChanges() {
    this.groupForm = this.data.form;
    if (this.isAiGenerated && this.data.level === 0) {
      this.computeKeywordCounts();
    }
  }

  toggleGroups(): void {
    this.groupsCollapsed = !this.groupsCollapsed;
  }

  private computeKeywordCounts(): void {
    const groups = this.groupForm.controls.groups as UntypedFormArray;
    if (!groups) return;
    this.includedCount = 0;
    this.excludedCount = 0;
    groups.controls.forEach((group: UntypedFormGroup) => {
      this.countFiltersRecursive(group);
    });
  }

  private countFiltersRecursive(group: UntypedFormGroup): void {
    const filters = group.get('filters') as UntypedFormArray;
    if (filters) {
      filters.controls.forEach((filter) => {
        if (filter.get('negated').value) {
          this.excludedCount++;
        } else {
          this.includedCount++;
        }
      });
    }
    const subGroups = group.get('groups') as UntypedFormArray;
    if (subGroups) {
      subGroups.controls.forEach((sub: UntypedFormGroup) => {
        this.countFiltersRecursive(sub);
      });
    }
  }

  addGroup(type) {
    this.query.addGroup(type);
  }

  duplicateGroup() {
    this.query.duplicateGroup(this.data.index);
  }

  delGroup() {
    this.query.delGroup(this.data.index);
  }

  addRule() {
    this.query.addRule(this.data.index, this.data.level);
  }

  delRule(index) {
    if (
      this.data.form.controls.filters.controls.length === 1 &&
      this.data.level === 1
    ) {
      this.delGroup();
    } else {
      if (
        this.data.form.controls.filters.controls.length === 2 &&
        this.data.level === 1
      ) {
        this.groupForm.controls.operator.setValue('and');
        if (this.data.form.get('filters')['controls'][0].status === 'INVALID') {
          this.data.form
            .get('filters')
            ['controls'][0].controls.field.setValue('text');
        }
        if (this.data.form.get('filters')['controls'][1].status === 'INVALID') {
          this.data.form
            .get('filters')
            ['controls'][1].controls.field.setValue('text');
        }
      }
      this.query.delRule(this.data.level, this.data.index, index);
    }
  }

  inOperator(value) {
    this.groupForm.controls.operator.setValue(value);
    if (value === 'near') {
      this.data.form.get('filters')['controls'].forEach((rule, index) => {
        this.data.form
          .get('filters')
          ['controls'][index].controls.field.setValue('word');
        const nearInput = this.data.form
          .get('filters')
          ['controls'][index].controls.input.value.trim();
        this.data.form
          .get('filters')
          ['controls'][index].controls.name.setValue(nearInput);
        this.data.form
          .get('filters')
          ['controls'][index].controls.value.setValue(nearInput);
      });
    }
  }

  inOperatorNear(value) {
    this.groupForm.controls.operator.setValue(value);
    this.data.form.get('filters')['controls'].forEach((rule, index) => {
      this.data.form
        .get('filters')
        ['controls'][index].controls.negated.setValue(false);
      this.data.form
        .get('filters')
        ['controls'][index].controls.field.setValue('text');
      const nearInput = this.data.form
        .get('filters')
        ['controls'][index].controls.input.value.trim();
      this.data.form
        .get('filters')
        ['controls'][index].controls.name.setValue(nearInput);
      this.data.form
        .get('filters')
        ['controls'][index].controls.value.setValue(nearInput);
    });
  }

  showOperator() {
    if (this.data.level === 0) {
      if (this.data.form.controls.groups.controls.length > 1) {
        return true;
      }
    }
    if (this.data.level === 1) {
      if (this.data.form.controls.filters.controls.length > 1) {
        return true;
      }
    }
    return false;
  }
}
